export const FirstPage = "first";
export const PreviousPage = "previous";
export const NextPage = "next";
export const LastPage = "last";
export const Cancel = "cross";